/** Central route/layout constants used by navigation and access-control services. */

export const ROUTE_ROOTS = {
    // Root route for the existing tenant and admin platform experience.
    PLATFORM: 'main',

    // Root route for the standalone user workspace experience.
    USER_WORKSPACE: 'workspace',
} as const;

export const APP_LAYOUTS = {
    TENANT_DASHBOARD: 'tenant-dashboard',
    USER_SIMPLE: 'user-simple',
} as const;

export const DASHBOARD_ROUTE_SEGMENTS = {
    DASHBOARD_HOME: 'dashboard-home',
    UPLOAD_RESULTS: 'upload-results',
    INDIVIDUAL_TEST_PAGE: 'individual-user-test-page',
    ACCESS_DENIED: 'access-denied',
    UPLOAD: 'upload',
    REGISTER_DOCUMENTS: 'registerdocuments',
    CONSOLIDATION_SETTINGS: 'consolidationsettings',
    RECONCILIATION_SETTINGS: 'reconciliationsettings',
    EXTRACTION_SETTINGS: 'extractionsettings',
    POST_PROCESS: 'post-process',
    ERP_IMPORT_DATA: 'erp-import-data',
    API_KEYS: 'api-keys',
    UPLOAD_MANAGER: 'uploadmanager',
    SUPPLIER_MANAGER: 'suppliermanager',
    CONFIGURATION_MANAGER: 'configurationmanager',
} as const;

export const WORKSPACE_ROUTE_SEGMENTS = {
    DOCUMENTS: 'documents',
} as const;

export const APP_ROUTES = {
    INDIVIDUAL_TEST_PAGE: `/${ROUTE_ROOTS.PLATFORM}/${DASHBOARD_ROUTE_SEGMENTS.INDIVIDUAL_TEST_PAGE}`,
    WORKSPACE_DOCUMENTS: `/${ROUTE_ROOTS.USER_WORKSPACE}/${WORKSPACE_ROUTE_SEGMENTS.DOCUMENTS}`,
    TENANT_DEFAULT: `/${ROUTE_ROOTS.PLATFORM}/${DASHBOARD_ROUTE_SEGMENTS.DASHBOARD_HOME}`,
    ACCESS_DENIED: `/${ROUTE_ROOTS.PLATFORM}/${DASHBOARD_ROUTE_SEGMENTS.ACCESS_DENIED}`,
} as const;
